import Helpers from '@helpers';
import * as React from 'react';
import { initChart } from './chart';
import { initGallery } from './gallery';
import { initImageZoom } from './image-zoom';
import { initPrice } from './price';
import { initRatings } from './ratings';
import { initTabs } from './tabs';
import { timer } from './timer';
import { goToReview } from './goToReview';
import { itemColorLimit } from './colorLimit';

class ProductDetailsController extends React.Component {
    constructor(props) {
        super(props);
    }

    public componentDidMount() {
        initChart();
        initGallery();
        initImageZoom();
        initRatings();
        initTabs();
        initPrice();
        timer();
        goToReview();
        itemColorLimit();
    }

    public render() {
        return null;
    }
}

Helpers.ReactHelper.createReactElement('ProductDetailsController', ProductDetailsController);
